import { Map } from 'immutable';
import { createSelector } from 'reselect';

import * as SpecialOffersConstants from './constants';
import * as D from './deps';
import * as SpecialOffersProtectedUtils from './protectedUtils';

export function getSpecialOffers(state) {
  return state.specialOffers || Map();
}

export const getSpecialOfferCode = createSelector(
  getSpecialOffers,
  D.PaymentsProtectedUtils.getPropFromMap(SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_CODE),
);

export const getSpecialOfferStatus = createSelector(
  getSpecialOffers,
  D.PaymentsProtectedUtils.getPropFromMap(SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_STATUS),
);

export const getSpecialOfferErrorMessage = createSelector(
  getSpecialOffers,
  D.PaymentsProtectedUtils.getPropFromMap(
    SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_ERROR_MESSAGE,
  ),
);

export const getSpecialOfferTrialIneligibleTier = createSelector(
  getSpecialOfferErrorMessage,
  D.PaymentsProtectedUtils.getPropFromMap(SpecialOffersConstants.ProductKeys.TIER),
);

export const getCampaignCopy = createSelector(
  getSpecialOffers,
  D.PaymentsProtectedUtils.getPropFromMap(SpecialOffersConstants.ReducerKeys.CAMPAIGN_COPY, null),
);

export const getAuthCampaignCopy = createSelector(
  getCampaignCopy,
  D.PaymentsProtectedUtils.getPropFromMap(
    SpecialOffersConstants.ReducerKeys.AUTH_CAMPAIGN_COPY,
    null,
  ),
);

export const getFTUXCampaignCopy = createSelector(
  getCampaignCopy,
  D.PaymentsProtectedUtils.getPropFromMap(
    SpecialOffersConstants.ReducerKeys.FTUX_CAMPAIGN_COPY,
    null,
  ),
);

export const getPaymentCampaignCopy = createSelector(
  getCampaignCopy,
  D.PaymentsProtectedUtils.getPropFromMap(
    SpecialOffersConstants.ReducerKeys.PAYMENT_CAMPAIGN_COPY,
    null,
  ),
);

export const getDelayedActivation = createSelector(
  getSpecialOffers,
  D.PaymentsProtectedUtils.getPropFromMap(SpecialOffersConstants.ReducerKeys.DELAYED_ACTIVATION),
);

export const getRedemptionAuthEntry = createSelector(
  getSpecialOffers,
  D.PaymentsProtectedUtils.getPropFromMap(SpecialOffersConstants.ReducerKeys.AUTH_LANDING_PAGE),
);

export const getSpecialOfferProductGroups = createSelector(
  getSpecialOffers,
  D.PaymentsProtectedUtils.getPropFromMap(
    SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_PRODUCTS,
    null,
  ),
);

export const getSpecialOfferPaypalProductGroup = createSelector(
  getSpecialOfferProductGroups,
  SpecialOffersProtectedUtils.getSpecialOfferProductGroupByProvider(
    D.PaymentsConstants.PaymentProviders.PAYPAL,
  ),
);

export const getSpecialOfferProduct = createSelector(
  getSpecialOfferProductGroups,
  SpecialOffersProtectedUtils.getSpecialOfferProduct,
);

export const getSpecialOfferInitialProduct = createSelector(
  getSpecialOfferProduct,
  D.PaymentsProtectedUtils.getPropFromMap(D.PaymentsConstants.ProductKeys.INITIAL_PRODUCT, null),
);

export const getNonPaymentBackedVendorSku = createSelector(
  getSpecialOfferProduct,
  D.PaymentsProtectedUtils.getPropFromMap(D.PaymentsConstants.ProductKeys.VENDOR_SKU, null),
);

export const getSpecialOfferProductType = createSelector(
  getSpecialOfferInitialProduct,
  D.PaymentsProtectedUtils.getPropFromMap(D.PaymentsConstants.ProductKeys.PRODUCT_TYPE, null),
);

export const isSpecialOfferPaymentBacked = createSelector(
  getSpecialOfferProductType,
  D.PaymentsProtectedUtils.isEqual(D.PaymentsConstants.productTypes.PAYMENT_BACKED_CODE),
);

export const getSpecialOfferDurationTime = createSelector(
  getSpecialOfferInitialProduct,
  D.PaymentsProtectedUtils.getPropFromMap(D.PaymentsConstants.ProductKeys.DURATION_TIME, null),
);

export const getSpecialOfferDurationType = createSelector(
  getSpecialOfferInitialProduct,
  D.PaymentsProtectedUtils.getPropFromMap(D.PaymentsConstants.ProductKeys.DURATION_TYPE, null),
);

export const getSpecialOfferDiscountType = createSelector(
  getSpecialOfferInitialProduct,
  D.PaymentsProtectedUtils.getPropFromMap(
    D.PaymentsConstants.ProductKeys.DISCOUNT_TYPE,
    D.PaymentsConstants.discountTypes.NONE,
  ),
);

export const getSpecialOfferTier = createSelector(
  getSpecialOfferInitialProduct,
  D.PaymentsProtectedUtils.getPropFromMap(D.PaymentsConstants.ProductKeys.PRODUCT_TIER),
);

export const getSpecialOfferPlanName = createSelector(
  getSpecialOfferTier,
  getSpecialOfferDiscountType,
  D.PaymentsUtils.getPlanName,
);

export function isInSpecialOfferFlow(state) {
  return !!getSpecialOfferStatus(state);
}

export const getSpecialOfferCampaignId = createSelector(
  getSpecialOffers,
  D.PaymentsProtectedUtils.getPropFromMap(
    SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_CAMPAIGN_ID,
  ),
);
